module.exports = __webpack_public_path__ + "static/media/Notification.35cfe477.svg";